import PropTypes from "prop-types";
import React, { Component } from "react";
import { MSpinner } from "components/Shared";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { DataTable, TableBody, TableRow } from "react-md/lib/DataTables";

class FormIssues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  render() {
    const { isFetching, caseForms, comparableValidationResult, items } = this.props;
    return (
      <div className="case-header">
        <Card className="md-cell md-cell--12"
          expanded={!this.state.collapsed}
          onExpanderClick={this.toggle}>
          <CardTitle
            title="Form Validation"
            style={{ cursor: "pointer" }}
            onClick={this.toggle}
            expander />
          <CardText expandable>
            {isFetching
              ? <MSpinner />
              : <FormIssuesList items={items} caseForms={caseForms} comparableValidationResult={comparableValidationResult} />
            }
          </CardText>
        </Card>
      </div>
    );
  }
}

FormIssues.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.array,
  caseForms: PropTypes.array.isRequired,
  comparableValidationResult: PropTypes.array.isRequired
};

class FormIssuesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pnxExpanded: {},
      compsExpanded: false,
    };
    this.togglePnx = this.togglePnx.bind(this);
    this.toggleComps = this.toggleComps.bind(this);
  }

  togglePnx(formName) {
    let pnxCol = {...this.state.pnxExpanded};
    pnxCol[formName] = pnxCol[formName] ? false : true;
    this.setState({ pnxExpanded: pnxCol });
  }
  toggleComps() {
    this.setState({ compsExpanded: !this.state.compsExpanded });
  }

  render() {
    const { items, comparableValidationResult } = this.props;

    if (items.length == 0 && !comparableValidationResult.length) {
      return <p>No Form Validation issues.</p>;
    }

    let failedPerForm = {};
    items.map((result) => {
      if(failedPerForm[result.formName]){
        failedPerForm[result.formName].push({...result});
      } else {
        failedPerForm[result.formName] = [];
        failedPerForm[result.formName].push({...result});
      } 
    });

    return (
      <div className="veros-override-grid">
        <div className="md-text-left md-table-column--header md-text--secondary" style={{ height: "auto" }}>
          Form Action Message
      </div>
        <DataTable plain className="md-cell--12 md-data-table__scroll-wrapper"
          style={{ maxHeight: 500, borderTopColor: "lightgray", borderTopStyle: "solid", borderTopWidth: "thin" }}>
          <TableBody>
            {Object.keys(failedPerForm).map(formName => (
              <TableRow key={formName}>
                <Card className="md-cell md-cell--12"
                  expanded={this.state.pnxExpanded[formName]}
                  onExpanderClick={() => this.togglePnx(formName)}>
                  <CardTitle
                    title={`${formName} has ${failedPerForm[formName].length} failed validation${failedPerForm[formName].length === 1 ? "" : "s"}.`}
                    style={{ cursor: "pointer" }}
                    onClick={() => this.togglePnx(formName)}
                    expander />
                  <CardText expandable>
                    <b>{formName}</b>
                      <ul>
                        {failedPerForm[formName]?.map(s => {
                          return s.messages.map(p => (<li key={p}>{p}</li>));
                        })}
                      </ul>    
                  </CardText>
                </Card>
              </TableRow>
            ))}
            <TableRow>
              <Card className="md-cell md-cell--12"
                expanded={this.state.compsExpanded}
                onExpanderClick={this.toggleComps}>
                <CardTitle
                  title={`Comparables with Comparable Search has ${comparableValidationResult.length} failed validation${comparableValidationResult.length === 1 ? "" : "s"}.`}
                  style={{ cursor: "pointer" }}
                  onClick={this.toggleComps}
                  expander />
                <CardText expandable>
                  <ul>
                    {comparableValidationResult.map(s => (<li key={s.message}>{s.message}</li>))}
                  </ul>
                </CardText>
              </Card>
            </TableRow>
          </TableBody>
        </DataTable>
      </div>
    );
  }
}

FormIssuesList.propTypes = {
  items: PropTypes.array.isRequired,
  caseForms: PropTypes.array.isRequired,
  comparableValidationResult: PropTypes.array.isRequired
};

export { FormIssues, FormIssuesList };
